<script setup>
import {useRoute} from "vue2-helpers/vue-router";
import needsService from "@/services/needs.service";
import {ref, onMounted} from "vue";

const route = useRoute();
const need = ref(null);
const startups = ref([]);

onMounted(() => {
    getInfo();
    getStartups();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);
    need.value = data;
}

async function getStartups() {
    const {data} = await needsService.getStartups(route.params.id);
    startups.value = data;
}

async function getNewAiMatches() {
    await needsService.getNewAiMatches(route.params.id);
    await getStartups();
}
</script>

<template>
    <div v-if="need">
        {{need.name}}
        {{need.description}}

        <div>
            Startups:
            <div v-for="startup in startups" :key="startup.id">
                {{startup.name}}
            </div>
        </div>

        <a class="link" @click="getNewAiMatches">Get New Matches</a>
    </div>
</template>

<style scoped>

</style>
